module.exports = __webpack_public_path__ + "img/illust-404.cf3c518.png";